export default __webpack_public_path__ + "static/media/pexels-rodnae-productions-5592513.d0d5788b.mp4";